import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, light = false }) => (
  <p className={`text-xs sm:text-sm uppercase tracking-[0.25em] font-bold mb-5 ${light ? "text-ochre" : "text-terracotta"}`}>
    {children}
  </p>
);

export const Tag = ({ children, tone = "terracotta" }) => {
  const tones = {
    terracotta: "bg-terracotta/10 text-terracotta border-terracotta/30",
    ochre: "bg-ochre/15 text-earth border-ochre/40",
    blush: "bg-blush/40 text-earth border-blush",
    charcoal: "bg-charcoal text-cream border-charcoal",
    cream: "bg-cream text-charcoal border-cream",
  };
  return (
    <span className={`inline-block text-[11px] uppercase tracking-[0.18em] font-bold px-4 py-1.5 rounded-full border ${tones[tone]}`}>
      {children}
    </span>
  );
};
